import React from 'react';
import { FiGithub, FiLinkedin, FiTwitter, FiMail, FiFacebook, FiGitBranch } from 'react-icons/fi';
import { SiX } from 'react-icons/si';
import { personalInfo, socialLinks } from '../data/portfolioData';
import { trackEvent } from '../utils/analytics';

const iconMap = {
  github: FiGithub,
  linkedin: FiLinkedin,
  twitter: FiTwitter,
  email: FiMail,
  facebook: FiFacebook,
  x: SiX,
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <span className="footer-item">
          <FiGitBranch /> dev
        </span>
        <span className="footer-item">UTF-8</span>
        <span className="footer-item">JavaScript React</span>
      </div>

      <div className="footer-center">
        <span className="footer-item">
          Made with &lt;Love /&gt; by {personalInfo.name}
        </span>
      </div>

      <div className="footer-right">
        {socialLinks.map((link) => {
          const Icon = iconMap[link.icon] || FiGithub;
          return (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-item footer-social"
              onClick={() =>
                trackEvent('social_click', {
                  network: link.name,
                  location: 'footer',
                })
              }
            >
              <Icon />
            </a>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
